// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__sZD8s","imageUploader":"EGiftCard_imageUploader__1os1n"};